import React from 'react';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import Grid from 'Components/frameworks/grid/Grid';
const ratio = ratioUtils.VALUES.XL;
export const SearchResultsPlaceholder = ({ nbItems }: { nbItems: number }) => (
  <Grid>
    {Array.from(
      {
        length: nbItems,
      },
      (_a, i) => (
        <article
          className="relative flex flex-col bg-white"
          data-testid="search-results-placeholder-item"
          key={i}
        >
          <div
            className="bg-lightGrey"
            style={{
              paddingBottom: `${100 * ratio}%`,
            }}
          />
          <div className="relative bg-white">
            <div className="flex w-full items-stretch text-inherit no-underline">
              <div className="flex-1 flex-col overflow-hidden py-5">
                <div className="mb-5 mt-5 flex h-[0.6rem] w-4/5 bg-lightGrey" />
                <div className="mb-5 flex h-[0.6rem] w-3/5 bg-lightGrey" />
              </div>
            </div>
          </div>
        </article>
      ),
    )}
  </Grid>
);
